import { CategoryGender } from "./category.utils";

type ValidationResult<T> =
  | { isValid: true; error: null }
  | { isValid: false; error: T };

export enum CategoryNameError {
  Required,
  Duplicated,
}

export function validateCategoryName<T extends { id: number; name: string }>(
  name: string,
  categories: T[],
  selectedCategoryId: number | null
): ValidationResult<CategoryNameError> {
  if (!name.trim()) {
    return { isValid: false, error: CategoryNameError.Required };
  }

  const isDuplicate = categories.some(
    (category) =>
      category.name.trim().toLowerCase() === name.trim().toLowerCase() &&
      category.id !== selectedCategoryId
  );

  if (isDuplicate) {
    return { isValid: false, error: CategoryNameError.Duplicated };
  }

  return { isValid: true, error: null };
}

export enum CategoryGenderError {
  Required,
}

export function validateCategoryGender(
  gender: CategoryGender | null
): ValidationResult<CategoryGenderError> {
  if (!gender) {
    return { isValid: false, error: CategoryGenderError.Required };
  }

  return { isValid: true, error: null };
}

export enum CategoryAgeRangeError {
  Required,
}

export function validateCategoryAgeRange(
  ageRangeId: number | null
): ValidationResult<CategoryAgeRangeError> {
  if (ageRangeId == null) {
    return { isValid: false, error: CategoryAgeRangeError.Required };
  }

  return { isValid: true, error: null };
}
